import styled from 'styled-components'
import { Button } from '@pinchenterprisesnpm/friday-ui'

export const StyledAddButton = styled(Button)`
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`
